export function ToLocaleString(e: string | number, text: string) {
  if (typeof e === "string") {
    return `${Number(e).toLocaleString()}  ${text}`;
  } else return `${e.toLocaleString()}  ${text}`;
}
